import { render, staticRenderFns } from "./HolidayEdit.vue?vue&type=template&id=916a29e4"
import script from "../../controllers/holiday/holiday-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/holiday/holiday-edit.js?vue&type=script&lang=js&external"
import style0 from "./HolidayEdit.vue?vue&type=style&index=0&id=916a29e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports